import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Text } from '@blueprint/text';
import { Checkbox } from '@blueprint/checkbox';

export const SubTitle = styled(Text)(
    ({ theme: { colors, spacing } }) => css`
        color: ${colors['text-body']};
        margin-bottom: ${spacing['24px']};
    `
);

export const AvailabilityTable = styled('table')(
    ({ theme: { spacing } }) => css`
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;

        thead {
            th {
                padding-bottom: ${spacing['16px']};
                padding-left: ${spacing['16px']};

                &.dayOfWeek {
                    text-indent: -999em;
                    width: 3rem;
                }
            }
        }

        td {
            padding: 0 0 ${spacing['16px']};

            &.availability {
                padding-left: ${spacing['16px']};
            }
        }
    `
);

export const AvailabilityCheckbox = styled(Checkbox)(
    ({ theme: { colors } }) => css`
        display: flex;
        align-items: center;
        justify-content: center;

        label {
            padding: 1rem;
            align-item: center;
            justify-content: center;
        }

        input[type='checkbox'] ~ {
            span + span {
                border-radius: 0.25rem;
                text-indent: -999em;
                z-index: auto;
                padding: 0;
                margin: 0;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                position: absolute;
                background-color: ${colors['white']};
            }
            .checkbox_icon_wrapper {
                padding: 0;
                margin: 0;
                left: 0;
                z-index: 1;
            }
        }
        input[type='checkbox'][disabled] ~ {
            span + span {
                background: ${colors['graphic-background-accent']};
                cursor: default;
            }
            .checkbox_icon_wrapper {
                opacity: 0.4;
                cursor: default;
            }
        }
    `
);
